<template>
  <div class="max-w-screen-2xl mx-auto px-4 md:px-10">
    <div class="bg-white rounded-xl px-8 md:px-16 py-12 font-light">
      <diamond-detail-fluorescence-content :fluorescence="fluorescence">
        <template #title>
          <base-headline class="!text-2xl mb-6 !normal-case !tracking-normal">
            {{ t("components.diamonds.details.fluorescence.title") }}:
            {{ initialFluorescenceLabel }}
          </base-headline>
        </template>
      </diamond-detail-fluorescence-content>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailFluorescenceContent from "@/components/diamonds/details/DiamondDetailFluorescenceContent.vue";

const { t } = useI18n();

const props = defineProps<{
  fluorescence: string | string[];
}>();

const getNormalizedFluorescence = (f: string) => {
  if (!f) return "n";
  f = f.toUpperCase();
  if (f === "N" || f === "NONE" || f === "NON" || f === "KEINE") return "n";
  if (
    f === "SL" ||
    f === "SLIGHT" ||
    f === "WEAK" ||
    f === "SCHWACH" ||
    f === "FAINT"
  )
    return "sl";
  if (f === "F" || f === "MEDIUM" || f === "MITTEL") return "f";
  return f.toLowerCase();
};

const fluorescences = [
  { key: "f", label: "Medium" },
  { key: "sl", label: "Weak" },
  { key: "n", label: "None" },
];

const initialFluorescenceLabel = computed(() => {
  const fluorescenceValue = Array.isArray(props.fluorescence)
    ? props.fluorescence[0]
    : props.fluorescence;
  const normalized = getNormalizedFluorescence(fluorescenceValue);
  const found = fluorescences.find((f) => f.key === normalized);
  return found ? found.label : fluorescenceValue;
});
</script>

<style scoped></style>
